import { Col, PageHeader, Row } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { LEFT_COL_WIDTH } from 'utils/constants';
import { cssMediaBreakpoints } from 'utils/responsiveQuery/breakpoints';
import TasksAndRunsWithoutTaskSwitch from '../TaskListPage/parts/TasksAndRunsWithoutTaskSwitch/TasksAndRunsWithoutTaskSwitch';
import RoutesWithotTaskFiltersCard from '../TaskListPage/parts/RoutesWithotTaskFiltersCard/RoutesWithotTaskFiltersCard';
import RoutesWithoutTaskListCard from 'app/components/RouteListCards/RoutesWithoutTaskListCard/RoutesWithoutTaskListCard';
import RunsWithoutTaskMapCard from '../TaskListPage/parts/RunsWithoutTaskMapCard/RunsWithoutTaskMapCard';
import { useRoutesWithoutTaskPage } from './hooks/useRoutesWithoutTaskPage';
import ShowIfDesktop from 'utils/responsiveQuery/ShowIfDesktop';
import ShowIfMobileOrTablet from 'utils/responsiveQuery/ShowIfMobileOrTablet';

interface IProps {}

const RightCol = styled(Col)`
  height: calc(100vh - 170px);
  ${cssMediaBreakpoints.mobileOrTablet} {
    height: auto;
  }
`;

const RoutesWithoutTaskPage: FC<IProps> = () => {
  const { mobileOrTablet, responsivePadding, t } = useRoutesWithoutTaskPage();

  return (
    <>
      <PageHeader
        className="page-header"
        title={t('Task.List.Tasks', 'Tasks')}
      />
      <Row
        wrap={mobileOrTablet}
        gutter={responsivePadding}
        style={{
          paddingLeft: responsivePadding,
          paddingTop: responsivePadding,
          width: '100%',
        }}
      >
        <Col
          style={{
            paddingBottom: 6,
            minWidth: mobileOrTablet ? '100%' : LEFT_COL_WIDTH,
            maxWidth: mobileOrTablet ? '100%' : LEFT_COL_WIDTH,
            maxHeight: mobileOrTablet ? 'unset' : `calc(100vh - 164px)`,
            display: 'flex',
            flexDirection: 'column',
            marginTop: mobileOrTablet ? '12px' : 0,
          }}
          order={2}
          lg={{ order: 1 }}
        >
          <ShowIfDesktop>
            <TasksAndRunsWithoutTaskSwitch />
          </ShowIfDesktop>

          <RoutesWithotTaskFiltersCard />
          <RoutesWithoutTaskListCard />
        </Col>

        <RightCol
          flex="auto"
          order={1}
          lg={{ order: 2 }}
          style={{ overflow: 'hidden' }}
        >
          <ShowIfMobileOrTablet>
            <TasksAndRunsWithoutTaskSwitch />
          </ShowIfMobileOrTablet>
          <RunsWithoutTaskMapCard />
        </RightCol>
      </Row>
    </>
  );
};

export default RoutesWithoutTaskPage;
